import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment'
import { ExamService } from 'src/app/services/Exam/exam.service';


@Component({
  selector: 'app-admit-card-schedule-setup',
  templateUrl: './admit-card-schedule-setup.component.html',
  styleUrls: ['./admit-card-schedule-setup.component.css']
})
export class AdmitCardScheduleSetupComponent implements OnInit {

  ClassList: any;

  constructor(private admitservice: ExamService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  ExamModel = {
    ClassID: 0,
    TermID:0,
    ExamMapID: 0,
  }

  Clear() {
    this.ExamModel.ClassID = 0;
    this.ExamModel.TermID = 0;
    this.ExamModel.ExamMapID = 0;
    this.ListExam = [];
   
    this.Submitted = false;
  };

  ListExam = [];

  Submitted = false;
  SaveExamSubjectScheduleSetup() {
   this.Submitted = true;
   for (var i = 0; i < this.ListExam.length; i++) {
    if (this.ListExam[i].IsActive && this.ListExam[i].ExamDate != null && this.ListExam[i].ExamDate != '') {
      this.ListExam[i].ExamDate = moment(this.ListExam[i].ExamDate).format('DD-MMM-YYYY');
    }
   
  }
      this.spinnerService.show();
      this.admitservice.SaveExamSubjectScheduleSetup(JSON.stringify(this.ExamModel), JSON.stringify(this.ListExam)).subscribe((data: any) => {
       if (data.webResponse.Status) {
          this.GetExamSubjectScheduleSetup();
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    

  };
  ValidateDropdown() {
    return this.ExamModel.ClassID == 0 || this.ExamModel.TermID == 0;
};
  ExamScheduleList = [];
  Exam=[];
  GetExamSubjectScheduleSetup() {
    this.Submitted = true;
    this.ListExam = [];
    if (!this.ValidateDropdown()) {
    this.spinnerService.show();
    this.admitservice.GetExamSubjectScheduleSetup(JSON.stringify(this.ExamModel)).subscribe((data: any) => {
      this.Exam = data.ListExam;
      for (var i = 0; i < this.Exam.length; i++) {
        var itemBo = {
            IsActive: this.Exam[i].IsActive,
            CourseName: this.Exam[i].CourseName,
            CourseID: this.Exam[i].CourseID,
            ExamDate: this.Exam[i].ExamDate != null && this.Exam[i].ExamDate != '' ? moment(this.Exam[i].ExamDate).format('DD-MMM-YYYY') : '',
            ExamSubjectScheduleSetupID: this.Exam[i].ExamSubjectScheduleSetupID,
        }
        this.ListExam.push(itemBo);
    }
      this.spinnerService.hide();

    });
  }
  };



 

  ngOnInit() {
    this.GetAllClass();    
  }

  GetAllClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
     
    });
  };
  TermList=[];
  GetTerm  () {
  this.TermList = [];
  this.ListExam = [];
  this.ExamModel.TermID = 0;
  this.ExamModel.ExamMapID = 0;
   var ItemBo = {
       ItemId: this.ExamModel.ClassID
   }
    this.lookupservice.GetLookupsList('ExamTerm', JSON.stringify(ItemBo)).subscribe( (data)=> {
       this.TermList = data.LookupItems;
       
   });
};
  ExamMasterList=[];
  GetExamMaster  () {
    this.spinnerService.show();
   this.ListExam = [];
   this.ExamMasterList = [];
   this.ExamModel.ExamMapID = 0;
   var item = {
       ItemId: this.ExamModel.ClassID,
       ItemId2: this.ExamModel.TermID
   }
    this.lookupservice.GetLookupsList('ExamEntry', JSON.stringify(item)).subscribe( (data)=> {
       this.ExamMasterList = data.LookupItems;
        this.spinnerService.hide();

   });
};
}
